import React, { Fragment } from 'react';
import { TermsHelmet } from '../components/MoiPayHelmet';
import TermsScreen from '../components/terms/TermsScreen';

export default function Terms() {
  return (
    <Fragment>
      <TermsHelmet />
      <TermsScreen />
    </Fragment>
  );
} 